import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiProvider } from 'src/app/services/api-providers/api-provider';
import { AuthProviderService } from 'src/app/services/api-providers/auth-provider.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent  implements OnInit {

  forgotPasswordForm: FormGroup;
  
  constructor(
    private readonly builder        : FormBuilder,
    private readonly router         : Router,
    private readonly apiProvider    : AuthProviderService,
    private readonly alertController: AlertController  
  ) { }

  ngOnInit() {
    this.forgotPasswordForm = this.builder.group({
      username: new FormControl('', [Validators.required, Validators.email])
    });
  }

  submitForgotPassword(){
    if(this.forgotPasswordForm.valid){
      this.apiProvider.forgotPassword(this.forgotPasswordForm.get("username").value).subscribe(
        {
          next : async (res) => {
            let alert = await this.alertController.create({
              buttons : ['ok'],
              message : "Un courriel de réinitialisation a été envoyé à cette adresse. (verifier vos spams)"
            });
            alert.present();
          },
          error : async (err) => {
            console.error(err);
            let alert = await this.alertController.create({
              buttons : ['ok'],
              message : "Erreur du serveur"
            });
            alert.present();
          }
        }
      )

    }
  }

  
  redirect(){
    this.router.navigateByUrl('');
  }

}
